import { all } from 'redux-saga/effects';

import { watchApp } from './sagas/app';
import { watchActions } from './sagas/actions';
import { watchAppendix } from './sagas/appendix';
import { watchApprovals } from './sagas/approvals';
import { watchExternalOfferings } from './sagas/externalOfferings';
import { watchForms } from './sagas/forms';
import { watchPortfolio } from './sagas/portfolio';
import { watchRequests } from './sagas/requests';
import { watchService } from './sagas/service';
import { watchServicesApp } from './sagas/servicesApp';
import { watchSubmission, watchSubmissionPoller } from './sagas/submission';
import { watchSettingsForms } from './sagas/settingsForms';
import { watchSettingsCategories } from './sagas/settingsCategories';
import { watchSettingsAppendix } from './sagas/settingsAppendix';
import { watchSettingsPortfolio } from './sagas/settingsPortfolio';
import { watchSettingsService } from './sagas/settingsService';

export default function*() {
  yield all([
    watchApp(),
    watchActions(),
    watchAppendix(),
    watchApprovals(),
    watchExternalOfferings(),
    watchForms(),
    watchPortfolio(),
    watchRequests(),
    watchService(),
    watchServicesApp(),
    watchSubmission(),
    watchSubmissionPoller(),
    watchSettingsForms(),
    watchSettingsCategories(),
    watchSettingsAppendix(),
    watchSettingsPortfolio(),
    watchSettingsService(),
  ]);
}
